<template>
  <div class="d-flex align-center justify-center as-bg-login" >
    <v-sheet width="400" class="mx-auto as-form-login">
      <v-form fast-fail @submit.prevent="login">
        <router-link to="/">
          <v-img src="@/assets/logo2.png" alt="" class=""/>
        </router-link>
        <v-text-field variant="outlined" color="cyan-darken-4" v-model="correo" type="email" label="Correo Electronico" @keyup.enter="login()"></v-text-field>
        <v-text-field :append-inner-icon="show ? 'mdi-eye':'mdi-eye-off'" :type="show? 'text':'password'" 
        variant="outlined" color="cyan-darken-4" v-model="password" label="Contraseña" @keyup.enter="login()"
        @click:append-inner="show=!show"
        ></v-text-field>

        <v-btn type="button" @click="login()" color="cyan-darken-4" block class="mt-2" >INGRESAR</v-btn>
        <br>
      </v-form>
  
    </v-sheet>
  </div>
  <v-snackbar v-model="snackbar"  :timeout="2000" color="error"   >
      <p class="text-center">Usuario  y/o contraseña incorrecto.</p>
  </v-snackbar>

  <v-overlay
      :model-value="loading"
      class="align-center justify-center"
    >
    <v-progress-circular
      :width="5"
      color="cyan"
      indeterminate
      size="80"
    ></v-progress-circular>
    </v-overlay>
 
</template>

<script>
import { defineComponent } from 'vue';
import Login from "@/services/Login";
import {useRouter} from 'vue-router';



export default defineComponent ({
  name:"LoginPage",
  data() {
    let correo="";
    //let password="lunetixogemS";
    let password="";
    const auth= new Login();
    const router=useRouter();
    const snackbar=false;
    const loading=false;
    const show=false;
    return { correo, password,  auth, router, snackbar, loading,show };
  },
  methods: {
    async login() {
      this.loading=true;

      setTimeout(async () => {
        const respuesta = await this.auth.loginUser(this.correo, this.password);
        this.loading = false; //una vez recibida la respuesta ocultar el indicador de progressbar

        if (respuesta) {
          this.router.push("dashboard");
        } else {
          this.snackbar = true;
        }
      }, 500);

    },
  }
});



</script>
